// components/BelgianRouterWrapper.jsx
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * This component intercepts Belgian domain navigation and adds /fr prefix
 * WITHOUT reloading the page
 */
const BelgianRouterWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isBelgianDomain = window.location.hostname.includes('chooseandwork.be');

  useEffect(() => {
    if (isBelgianDomain) {
      const currentPath = location.pathname;
      const currentSearch = location.search;
      const currentHash = location.hash;
      
      // Check if we need to add /fr prefix
      if (!currentPath.startsWith('/fr')) {
        const newPath = currentPath === '/' ? '/fr' : `/fr${currentPath}`;
        const fullPath = newPath + currentSearch + currentHash;
        
        console.log(`Belgian domain - Adding /fr prefix: ${currentPath} -> ${newPath}`);
        
        // Use React Router navigate (NO PAGE RELOAD)
        navigate(fullPath, { 
          replace: true,  // Replace current history entry
          state: { fromBelgianRedirect: true } // Optional state
        });
      }
    }
  }, [location.pathname, navigate, isBelgianDomain]);

  return children;
};

export default BelgianRouterWrapper;